
@if(file) {
  <div class="uploaded-files-list">
    @if(file.type !== 'file') {
      @if (file.type === 'image') {
        <img 
          [ngSrc]="(file.preview !== null && file.preview !== '') ? file.preview! : file.path ?? ''" 
          [disableOptimizedSrcset]="(file.path ?? '').endsWith('.gif')"
          [width]="150" 
          [height]="100" 
          [sizes]="'100vw, 100vw, 100vw'" 
          [alt]="file.filename" 
          priority="low" 
          class="upload-image" 
        />
      } @else {
        <div class="image-preview-overlay" (click)="openGallery(file)"></div>
      }
    } @else if (file.type === 'file') {
      <div class="fileIcons" (click)="documentService.openDocument(file)">
        <div class="file-icon-container" [class]="documentService.getDocumentClass(file)">
          <span class="fileIconBase mts-icon mts-icon-filled fs-l lh-base">insert_drive_file</span>
          <div class="file-type">{{ documentService.getDocumentExtension(file) }}</div>
        </div>
      </div>
    }
    <app-tooltip [type]="'File'" [opensOn]="'Auto'" [file]="file" [icon]="'info'" [cssClass]="'p-2'"></app-tooltip>

    @if(file.type !== 'file') {
      <div class="position-absolute top-0 end-0 me-1 me-sm-1 mt-1 mt-sm-0 icons" (click)="openGallery(file)">
        <app-icon-badge [style]="'default'" [fontSize]="'fs-5'" [fontColor]="'text-white'" [icon]="'visibility'"></app-icon-badge>
      </div>
    } @else {
      <div class="position-absolute top-0 end-0 me-1 me-sm-1 mt-1 mt-sm-0 icons" (click)="documentService.openDocument(file)">
        <app-icon-badge [style]="'default'" [fontSize]="'fs-5'" [fontColor]="'text-white'" [icon]="'visibility'"></app-icon-badge>
      </div>
    }

    <div class="overlay d-flex align-items-center">
      @if(position > 0) {
        <div class="left-arrow">
          <app-icon-badge [style]="'default'" [icon]="'chevron_left'" [fontColor]="'text-white'" (click)="moveFile(file, 'up')">
          </app-icon-badge>
        </div>
      }
      <div class="trash-icon">
        <app-icon-badge [style]="'default'" [icon]="removeBadge === 'trash' ? 'delete' : 'cancel'" [fontColor]="'text-white'" (click)="showDeleteOverlay(file)">
        </app-icon-badge>
      </div>
      @if (position < files.length - 1) {
        <div class="right-arrow">
          <app-icon-badge [style]="'default'" [icon]="'chevron_right'" [fontColor]="'text-white'" (click)="moveFile(file, 'down')">
          </app-icon-badge>
        </div>
      }
    </div>
  </div>
}
